import { render, staticRenderFns } from "./FullWidthDropdownMenu.vue?vue&type=template&id=33dce92b&scoped=true&"
import script from "./FullWidthDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./FullWidthDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthDropdownMenu.vue?vue&type=style&index=0&id=33dce92b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dce92b",
  null
  
)

export default component.exports